/**
 * Asynchronously loads the component for BITESHomePageSearchJob
 */

import { lazyLoad } from "utils/loadable";

export const BITESHomePageSearchJob = lazyLoad(
  () => import("./index"),
  (module) => module.BITESHomePageSearchJob
);
